import { put } from 'redux-saga/effects';
import http from "axios/index";

import {
    VERIFY_USER,
} from '../../../api/constants'

import {
    removeSession,
    setSession,
    checkUser,
    getEmployees,
    getManagers
} from '../../actions'

import { getUrlParams } from '../../../utils/';
import OAuth from '../../../utils/OAuth2';
import moment from 'moment';
import swal from "sweetalert2";

const { url,
    authorizationPath,
    clientId,
    responseType,
    redirectUri,
    scope } = OAuth;

export function* checkToken() {
    try {
        const urlParams = getUrlParams();
        const urlCode = urlParams.code;
        if (urlCode && urlCode !== 'undefined') {
            window.localStorage.setItem('code', urlCode);
            swal.showLoading();

            yield put(checkUser({ 'code': urlCode, 'redirectUrl': redirectUri }));

        } else if (window.localStorage.getItem('auth') !== null) {
            const auth = JSON.parse(window.localStorage.getItem("auth"))
            if (auth != null) {
                var getEmployeeInfo = JSON.parse(window.localStorage.getItem("employeeInfo"));
                const expireDate = window.localStorage.getItem('expireDate');

                const now = moment(moment.now());
                const formattedExpireDate = moment(parseInt(expireDate));
                const duration = now.diff(formattedExpireDate, 'seconds');

                if (duration > 0) {
                    yield put(removeSession());
                } else {
                    const payload = { 'accessToken': getEmployeeInfo.accessToken, 'sso': getEmployeeInfo.sso }
                    yield verifyToken({ payload});
                }
            }

        }
        else {
            window.location = `${url + authorizationPath
                }?response_type=${responseType
                }&client_id=${clientId
                }&redirect_uri=${redirectUri
                }&scope=${scope}`;
        }

    } catch (error) {
        console.error("Error happened when try to check Token : ", error)
    }
}


export function* verifyToken({ payload }) {
    try {
        const token = payload.accessToken;
        const sso = payload.sso;
        var data = new URLSearchParams();
        data.append("accessToken", token);
        const response = yield http.post(VERIFY_USER, data);
        response.data.data.sso = sso;
        yield put(setSession(response.data.data));
        yield put(getEmployees(token));
        yield put(getManagers(token));
        swal.close();
    } catch (error) {
        yield put(removeSession());
        console.error("Error happened when try to verify Token.Error : ", error)
    }
}

